import {HELPER_SESSION_MINUTE_INTERVAL} from '../avcmpConfig';
import urls from '../modules/app/constants/urls';
import responseStatus from '../modules/app/constants/responseStatuses';

class HelperSession {
    reloadPage = () => {
        window.location.reload();
    };

    /**
     * Send request to server and check if session exists
     */
    verifyCheckerResponse = () => {
        return fetch(urls.authValidate, {
            cache: 'no-cache',
            credentials: 'include',
        })
            .then(response => {
                if (responseStatus.HTTP_FORBIDDEN === response.status) {
                    throw new Error('Session expired');
                } else if (responseStatus.HTTP_OK !== response.status) {
                    throw new Error('Bad response from server');
                }

                return response.json();
            })
            .then(json => {
                if (!json.is_authenticated) {
                    this.reloadPage();
                }
            });
    };

    checkSessionWithInterval = (interval = HELPER_SESSION_MINUTE_INTERVAL) => {
        setInterval(() => {
            this.verifyCheckerResponse().catch(() => {});
        }, interval * 60 * 1000);
    };

    startListener = () => {
        this.checkSessionWithInterval();
    };
}

export default HelperSession;
